import React from 'react'
import { CollapsingBlock, InjectHtml } from '@/components/ui'
import type { IConditionsProps } from '../interfaces'

const LandingConditionsMobile: React.FC<IConditionsProps> = ({ conditions }) => {
  return (
    <div>
      {conditions?.map(({ caption, text }) => (
        <CollapsingBlock
          headingClass="h4 landing-constructor-conditions-row__caption"
          title={caption}
          className="landing-constructor-conditions-row background_white"
          key={caption}
        >
          <InjectHtml html={text} className="landing-constructor-conditions-row__content" />
        </CollapsingBlock>
      ))}
    </div>
  )
}

export default LandingConditionsMobile
